
import React from 'react';
import { ScreenSectionSymbols } from './PosScreen.Sections';

export function Content({ children }: React.PropsWithChildren): React.ReactNode {
	return children;
}

(Content as any)[ScreenSectionSymbols.Content] = true;

